<div class="ibox" ng-show="$ctrl.pendencias.length > 0">
  <div class="ibox-content">
    <div class="cf-grid">

      <div class="grid-row" ng-repeat="gleba in $ctrl.pendencias">
        <div class="heading">
          <h3>{{::gleba.descricao}}</h3>
          <small>{{ gleba.area | number:2}} ha</small>
          <a
            class="text-muted"
            uib-tooltip-template="'views/pendencias/grid-schedule-tooltip.html'"
            tooltip-placement="right"
            tooltip-append-to-body="true"
          >
          </a>
        </div>
        <div class="pendency-row">
          <div class="pendency-col" ng-repeat="task in gleba.pendencias track by task.id+task.tipoPendencia">
            <div
              class="pendency {{task.status == 1 ? 'in-progress' : ''}}"
              ng-class="$ctrl.taskClasses(task)"
              ng-click="$ctrl.redirectToTask(task)"
              uib-popover-template="'views/pendencias/grid-pending-popover.html'"
              popover-append-to-body="true"
              popover-placement="bottom"
              popover-trigger="mouseenter"
              popover-title="{{::task.tipo.descricao}}"
            >
              <i class="pull-left" ng-class="task.tipo.icon" aria-hidden="true"></i>
              <div class="infos" ng-switch="task.status">
                  <p>{{::task.tipo.descricao}}</p>
                  <h4 ng-if="$ctrl.singleDayTask(task)">{{task.dataFinal | date: 'dd/MM'}}</h4>
                  <h4 ng-if="!$ctrl.singleDayTask(task)">{{task.dataInicial | date: 'dd/MM'}} à {{task.dataFinal | date: 'dd/MM'}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
